export default "__VITE_ASSET__5fe2db73__"